import { cn } from "@/src/lib/utils";
import { Button } from "@/src/components/ui/Button";
import { Text } from "@/src/components/ui/Typography";

interface ExpertiseListItemProps {
  number: string;
  title: string;
  active: boolean;
  onSelect: () => void;
}

export function ExpertiseListItem({
  number,
  title,
  active,
  onSelect,
}: ExpertiseListItemProps) {
  return (
    <Button
      type="button"
      unstyled
      onClick={onSelect}
      className="flex items-baseline gap-4 text-left"
    >
      <Text
        as="span"
        size="labelMD"
        className={cn(
          "transition-colors duration-300",
          active ? "text-neutral-700" : "text-neutral-400",
        )}
      >
        {number}
      </Text>

      <Text
        as="span"
        size="titleMD"
        className={cn(
          "transition-colors duration-300",
          active ? "text-neutral-700" : "text-neutral-400",
        )}
      >
        {title}
      </Text>
    </Button>
  );
}
